export const events = {
  landing: "LANDING",
  landing_send: "LANDING_SEND",
  player_a: "PLAYER_A",
  player_b: "PLAYER_B",
  player_i: "PLAYER_I",
  player_e: "PLAYER_E",
  player_v: "PLAYER_V",
  form_v: "FORM_V",
  success: "SUCCESS",
  view: "VIEW"
}